import FooterSocial from "./component/footer-social";
import {Link} from "react-router-dom";
import {ADDRESS, EMAIL, PHONE, PHONE_STRING} from "../../utils/Constants";

const footer_contents = {
    logoLight: '/assets/images/logo/logo-dark.png',
    logoDark: '/assets/images/logo/logo-white.png',
    desc: '',
    add: '70-80 Upper St Norwich NR2',
    call: '',
    email: '',
    widgets: [
        {
            col: '3',
            class: 'explore-widget',
            widget_title: 'Online Platform',
            footer_links: [
                { link: 'about-1', title: 'About' },
                { link: 'course-style-1', title: 'Courses' },
                { link: 'team-1', title: 'Instructor' },
                { link: 'event-grid', title: 'Events' },
                { link: 'team-details', title: 'Instructor Profile' },
                { link: 'purchase-guide', title: 'Purchase Guide' }
            ]
        },
        {
            col: '2',
            class: 'quick-link-widget',
            widget_title: 'Links',
            footer_links: [
                { link: 'contact-us', title: 'Contact Us' },
                { link: 'gallery-grid', title: 'Gallery' },
                { link: 'blog-standard', title: 'News & Articles' },
                { link: 'faq', title: "FAQ's" },
                { link: 'sign-in', title: 'Sign In/Registration' },
                { link: 'coming-soon', title: 'Coming Soon' }
            ]
        }
    ]

}

const { logoDark, logoLight, desc, add, call, email, widgets } = footer_contents;

const Footer = ({ style_2, dark_bg,home_4 }) => {
    return (
        <footer className={`edu-footer ${style_2 ? style_2 : dark_bg ? 'footer-dark bg-image footer-style-3' : "footer-lighten bg-image footer-style-1"}`}>
            <div className={`footer-top ${style_2 ? "footer-top-2" : ""}`}>
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-3 col-md-6">
                            <div className="edu-footer-widget">
                                <div className="logo">
                                    <Link to={'/'}>
                                        <a>
                                            {!dark_bg && <>
                                                {!style_2 && <img className="logo-light" src={logoLight} alt="Corporate Logo" />}
                                                <img className="logo-dark" src={logoDark} alt="Corporate Logo" />
                                            </>}
                                        </a>
                                    </Link>

                                    <Link to={'/'}>
                                        <a>
                                            {dark_bg && <img className="logo-light" src={home_4?'/assets/images/logo/logo-white.png' :'/assets/images/logo/logo-light-2.png'} alt="Corporate Logo" />}
                                        </a>
                                    </Link>
                                </div>

                                <p className="description">{ADDRESS}</p>
                                <div className="widget-information">
                                    <ul className="information-list">
                                        <li><span>Tel:</span><a href={`tel:${PHONE}`}>{PHONE_STRING}</a></li>
                                        <li><span>Email:</span><a href={`mailto:${EMAIL}`} rel="noreferrer" target="_blank">{EMAIL}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className={`col-lg-1 col-sm-6`}>
                        </div>
                        <div className={`col-lg-4 col-sm-6`}>
                            <div className={`edu-footer-widget quick-link-widget`}>
                                <h4 className="widget-title">Faydalı Linkler</h4>
                                <div className="inner">
                                    <div className="footer-link link-hover">
                                        <ul>
                                            <li><a target="_blank" href="https://sem.cu.edu.tr">Sürekli Eğitim Merkezi</a></li>
                                            <li><a target="_blank" href="https://habermerkezi.cu.edu.tr">Haber Merkezi</a></li>
                                            <li><a target="_blank" href="https://cukurovateknokent.com">Çukurova Teknokent</a></li>
                                            <li><a target="_blank" href="https://bap.cu.edu.tr">BAP</a></li>
                                            <li><a target="_blank" href="https://muhendislik.cu.edu.tr">Ç.Ü. Mühendislik Fakültesi</a></li>
                                            {/*<li><a href="https://balcali.cu.edu.tr">Balcalı Hastanesi</a></li>*/}
                                            {/*<li><a href="http://radyo.cu.edu.tr">Üniversite Radyosu</a></li>*/}
                                            {/*<li><a href="https://zfauc.cu.edu.tr">Araştırma ve Uygulama Çiftliği</a></li>*/}
                                        </ul>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="edu-footer-widget">
                                <h4 className="widget-title">İletişim</h4>
                                <div className="inner">
                                    <p className="description">Detaylı bilgi almak ve gelişmlerden haberdar olmak için bizi takip edin</p>

                                    {/*<ul className="social-share icon-transparent">*/}
                                    {/*    <FooterSocial/>*/}
                                    {/*</ul>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="copyright-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="inner text-center">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;